module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leftbar-view elffy-dashboard",
    class: {
      'left-aside-toggle': _vm.toggle_aside
    }
  }, [_c('section', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row text-left"
  }, [_c('ProjectManageBoard', {
    attrs: {
      "user": _vm.user,
      "deal": _vm.deal,
      "project": _vm.project
    },
    on: {
      "update-project": _vm.updateProject,
      "update-deal": _vm.updateDeal
    }
  })], 1)])]), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13219843","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Deals/DealManagement.vue
// module id = 668
// module chunks = 4